var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}],model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }